module.exports = __webpack_public_path__ + "static/media/p6_face.74e4bfb8.png";